<template>
  <div class="box box--performance">
    <div class="box-inner">
      <div class="box-icon">
        <div class="box-icon-bg" :style="{background: company.colorPrimary}" />
        <img v-if="icon" :src="icon">
        <img v-else src="/web/performance_rating.svg">
      </div>
      <div class="box-content">
        <span class="box-tag">{{box.name}}</span>
        <span class="box-title">{{box.headline}}</span>
        <p>{{box.contentProject}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import settings from "@/settings";
export default {
  props: ['box'],
name: "EngagementProjectBox",
computed: {
  company() {
    return this.$store.getters.company
  },
  icon() {
    return settings.PERFORMANCE_ICONS[this.box._embedded.Icon.value]
  }
}
}
</script>

<style scoped>

</style>